export default {
      id: "circle-external-rusal_career-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "sprite-46b249.svg#circle-external-rusal_career-usage",
      toString: function () {
        return this.url;
      }
    }